export default __webpack_public_path__ + "static/media/Sprint_mob@2x.03d77b2f.png";